import { DropDownItemType } from "../../screens/TimeSheet"

export const categoryOfClientDropDown = [
    {
        value: "Red",
        label: "Red"
    },
    {
        value: "Yellow",
        label: "Yellow"
    },
    {
        value: "Green",
        label: "Green"
    },
]

export const serviceTaxRegisteredDropDown = [
    {
        value: "No",
        label: "No"
    },
    {
        value: "Yes",
        label: "Yes"
    }
]
export const serviceTaxPeriodDropDown = [
    {
        value: "None",
        label: "None"
    },
    {
        value: "6 Monthly",
        label: "6 Monthly"
    }
]

export const serviceTaxBasisDropDown = [
    {
        value: "None",
        label: "None"
    },
    {
        value: "Payments",
        label: "Payments"
    },
    {
        value: "Invoices",
        label: "Invoices"
    },
    {
        value: "Hybrid",
        label: "Hybrid"
    },
]


export const callFrequencyDropDown = [
    {
        value: "6a: Call every 2 days",
        label: "6a: Call every 2 days"
    },
    {
        value: "6b: Call every 1 week",
        label: "6b: Call every 1 week"
    },
    {
        value: "6c: Call every 2 weeks",
        label: "6c: Call every 2 weeks"
    },
    {
        value: "6d: Call every 1 month",
        label: "6d: Call every 1 month"
    },
    {
        value: "6e: Stop calling",
        label: "6e: Stop calling"
    },
]

export const leadCategaryDropdown=[
    {
        value:"HOT",
        label:"HOT"
    },
    {
        value:"WARM",
        label:"WARM"
    },
    {
        value:"COLD",
        label:"COLD"
    }
]

export const leadStatusDropdown=[
    {
        label:"Open",
        value: 1
    },
    {
        label:"Close",
        value: 0
    }
]

// export const leadStageDropDown = [
//     {
//         value: "1: Raw",
//         label: "1: Raw"
//     },
//     {
//         value: "2a: In-Progress",
//         label: "2a: In-Progress"
//     },
//     {
//         value: "2b: Interested",
//         label: "2b: Interested"
//     },
//     {
//         value: "2bii: Keep for emailer reach",
//         label: "2bii: Keep for emailer reach"
//     },
//     {
//         value: "2c: Won",
//         label: "2c: Won"
//     },
//     {
//         value: "3a: Archived",
//         label: "3a: Archived"
//     },
//     {
//         value: "3b: Bad",
//         label: "3b: Bad"
//     },
//     {
//         value: "4a: Require Accountant (Full Time)",
//         label: "4a: Require Accountant (Full Time)"
//     },
//     {
//         value: "4b: Require Accountant (Part Time)",
//         label: "4b: Require Accountant (Part Time)"
//     },
// ]

export const entityDropDown = [
    {
        label: "Foreign Company",
        value: "Foreign Company"
    },
    {
        label: "Foreign Limited Liability Partnership",
        value: "Foreign Limited Liability Partnership"
    },
    {
        label: "Government Department",
        value: "Government Department"
    },
    {
        label: "Hindu Undivided Family",
        value: "Hindu Undivided Family"
    },
    {
        label: "Incorporated Society/Club/AOP",
        value: "Incorporated Society/Club/AOP"
    },
    {
        label: "Individual",
        value: "Individual"
    },
    {
        label: "Limited Liability Partnership",
        value: "Limited Liability Partnership"
    },
    {
        label: "Local Authority",
        value: "Local Authority"
    },
    {
        label: "Others",
        value: "Others"
    },
    {
        label: "Partnership",
        value: "Partnership"
    },
    {
        label: "Private Limited Company",
        value: "Private Limited Company"
    },
    {
        label: "Public Limited Company",
        value: "Public Limited Company"
    },
    {
        label: "Public Sector Undertaking",
        value: "Public Sector Undertaking"
    },
    {
        label: "Sole Proprietorship",
        value: "Sole Proprietorship"
    },
    {
        label: "Statutory Body",
        value: "Statutory Body"
    },
    {
        label: "Trust",
        value: "Trust"
    },
    {
        label: "Unlimited Company",
        value: "Unlimited Company"
    },
]

export const contactTypeDropDown = [
    {
        label: "Client",
        value: "Client"
    },
    {
        label: "Prospect",
        value: "Prospect"
    },
    {
        label: "Lead",
        value: "Lead"
    },
    {
        label: "Supplier",
        value: "Supplier"
    },
    {
        label: "Other",
        value: "Other"
    },
    {
        label: "Client & Supplier",
        value: "Client & Supplier"
    },
    {
        label: "Prospect & Supplier",
        value: "Prospect & Supplier"
    },
    {
        label: "Lead & Supplier",
        value: "Lead & Supplier"
    }
]

export const clientTypeDropDown = [
    {
        label: "None",
        value: "None"
    },
    {
        label: "Farmer",
        value: "Farmer"
    },
    {
        label: "Business",
        value: "Business"
    },
    {
        label: "Investor",
        value: "Investor"
    },
    {
        label: "Clubs/Charities",
        value: "Clubs/Charities"
    },
    {
        label: "Non Trading",
        value: "Non Trading"
    },
    {
        label: "Corporate Trustee",
        value: "Corporate Trustee"
    },
    {
        label: "Individual",
        value: "Individual"
    },
    {
        label: "Lead",
        value: "Lead"
    },
]

export const turnOverDropdown=[
    {
        value:"0-0.5",
        label:"0-0.5 crore"
    },
    {
        value:"0.5-2",
        label:"0.5-2 crore"
    },
    {
        value:"2-10",
        label:"2-10 crore"
    },
    {
        value:"10-50",
        label:"10-50 crore"
    },
    {
        value:"50-100",
        label:"50-100 crore"
    },
    {
        value:"more than 100",
        label:"100 crore & more"
    }
]